import { takeLatest, put } from 'redux-saga/effects';

import {
    CANCEL_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_RAPIDO,
    CANCEL_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_RAPIDO_SUCCESS
} from '../actionTypes';

function* sagaCancelPatrimonioAlertaManutencaoCadastroRapido() {
  yield put({ type: CANCEL_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_RAPIDO_SUCCESS})
}

export default function* watchCancelPatrimonioAlertaManutencaoCadastroRapido() {
  yield takeLatest(CANCEL_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_RAPIDO, sagaCancelPatrimonioAlertaManutencaoCadastroRapido)
}
